import React from "react";
import { ArrowLeft } from "lucide-react";
import AttackSurface from "../graph/AttackSurface";

const AccountDetailView = ({ accountId, detailsData, summaryData, cloudAccounts, onBack }) => {
  // Get account info
  const getAccountInfo = () => {
    const account = cloudAccounts.find(acc => acc.awsAccountId === accountId);
    const accountData = summaryData?.accountBreakdown?.find(acc => acc.accountId === accountId);

    if (!accountData) {
      return {
        accountName: account?.alias || account?.description || accountId,
        accountId,
        totalFindings: 0,
        critical: 0,
        high: 0,
        medium: 0,
        low: 0,
        complianceRate: 0
      };
    }

    // Calculate compliance rate (assuming 80% as baseline for now)
    const complianceRate = accountData.totalFindings > 0 ? 
      Math.max(0, 100 - (accountData.totalFindings / 10)).toFixed(1) : 100;

    return {
      accountName: account?.alias || account?.description || accountId,
      accountId,
      totalFindings: accountData.totalFindings,
      critical: accountData.critical,
      high: accountData.high,
      medium: accountData.medium,
      low: accountData.low,
      complianceRate
    };
  };

  const accountInfo = getAccountInfo();
  console.log('AccountDetailView - accountId:', accountId);
  console.log('AccountDetailView - summaryData:', summaryData);
  console.log('AccountDetailView - accountBreakdown:', summaryData?.accountBreakdown);
  console.log('AccountDetailView - accountInfo:', accountInfo);

  // Filter details data for this account
  console.log('AccountDetailView - accountId:', accountId);
  console.log('AccountDetailView - detailsData length:', detailsData?.length);
  console.log('AccountDetailView - First detail:', detailsData?.[0]);
  
  // Get unique account IDs in the data
  const uniqueAccounts = [...new Set(detailsData?.map(f => f.accountId?.S || f.accountId) || [])];
  console.log('AccountDetailView - Unique accounts in data:', uniqueAccounts);
  
  const accountFindings = detailsData?.filter(finding => {
    const findingAccountId = finding.accountId?.S || finding.accountId;
    return findingAccountId === accountId;
  }) || [];
  
  console.log('AccountDetailView - accountFindings length:', accountFindings.length);

  return (
    <div>
      {/* Back Button */}
      <button
        onClick={onBack}
        className="btn btn-sm d-flex align-items-center gap-2"
        style={{
          backgroundColor: 'transparent',
          border: '1px solid #e2e8f0',
          color: '#64748b',
          padding: '8px 16px',
          borderRadius: '8px',
          transition: 'all 0.2s'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = '#f8fafc';
          e.currentTarget.style.borderColor = '#6D5BFF';
          e.currentTarget.style.color = '#6D5BFF';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = 'transparent';
          e.currentTarget.style.borderColor = '#e2e8f0';
          e.currentTarget.style.color = '#64748b';
        }}
      >
        <ArrowLeft size={16} />
        Back to Organization
      </button>

      {/* Account Header */}
      <div
        className="mt-4"
        style={{
          background: 'rgba(255, 255, 255, 0.7)',
          backdropFilter: 'blur(10px)',
          WebkitBackdropFilter: 'blur(10px)',
          borderRadius: '16px',
          border: '1px solid rgba(255, 255, 255, 0.3)',
          boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.15)',
          padding: '24px'
        }}
      >
        <h3 className="text-muted" style={{ fontWeight: '600', marginBottom: '8px' }}>
          {accountInfo.accountName}
        </h3>
        <p style={{ fontSize: '0.875rem', color: '#64748b', fontFamily: 'monospace', marginBottom: 0 }}>
          {accountInfo.accountId}
        </p>
      </div>

      {/* Account Metrics */}
      <div className="row g-4 mt-4">
        <div className="col-md-3">
          <div
            style={{
              background: 'rgba(255, 255, 255, 0.7)',
              backdropFilter: 'blur(10px)',
              WebkitBackdropFilter: 'blur(10px)',
              borderRadius: '16px',
              border: '1px solid rgba(255, 255, 255, 0.3)',
              boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.15)',
              padding: '20px',
              textAlign: 'center'
            }}
          >
            <div style={{ fontSize: '0.875rem', color: '#64748b', marginBottom: '8px' }}>Total Findings</div>
            <div style={{ fontSize: '2rem', fontWeight: '700', color: '#1e293b' }}>{accountInfo.totalFindings}</div>
          </div>
        </div>
        <div className="col-md-3">
          <div
            style={{
              background: 'rgba(255, 255, 255, 0.7)',
              backdropFilter: 'blur(10px)',
              WebkitBackdropFilter: 'blur(10px)',
              borderRadius: '16px',
              border: '1px solid rgba(255, 255, 255, 0.3)',
              boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.15)',
              padding: '20px',
              textAlign: 'center'
            }}
          >
            <div style={{ fontSize: '0.875rem', color: '#64748b', marginBottom: '8px' }}>Critical</div>
            <div style={{ fontSize: '2rem', fontWeight: '700', color: '#ef4444' }}>{accountInfo.critical}</div>
          </div>
        </div>
        <div className="col-md-3">
          <div
            style={{
              background: 'rgba(255, 255, 255, 0.7)',
              backdropFilter: 'blur(10px)',
              WebkitBackdropFilter: 'blur(10px)',
              borderRadius: '16px',
              border: '1px solid rgba(255, 255, 255, 0.3)',
              boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.15)',
              padding: '20px',
              textAlign: 'center'
            }}
          >
            <div style={{ fontSize: '0.875rem', color: '#64748b', marginBottom: '8px' }}>High</div>
            <div style={{ fontSize: '2rem', fontWeight: '700', color: '#f59e0b' }}>{accountInfo.high}</div>
          </div>
        </div>
        <div className="col-md-3">
          <div
            style={{
              background: 'rgba(255, 255, 255, 0.7)',
              backdropFilter: 'blur(10px)',
              WebkitBackdropFilter: 'blur(10px)',
              borderRadius: '16px',
              border: '1px solid rgba(255, 255, 255, 0.3)',
              boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.15)',
              padding: '20px',
              textAlign: 'center'
            }}
          >
            <div style={{ fontSize: '0.875rem', color: '#64748b', marginBottom: '8px' }}>Compliance</div>
            <div style={{ fontSize: '2rem', fontWeight: '700', color: '#10b981' }}>{accountInfo.complianceRate}%</div>
          </div>
        </div>
      </div>

      {/* Findings Details */}
      <div className="mt-4">
        <AttackSurface findingsData={accountFindings} />
      </div>
    </div>
  );
};

export default AccountDetailView;
